<template>
  <div class="container">
    <div class="row mt-2">
      <div class="col-md-12">
        <boton-atras :nombre_ruta="'Home'" />
      </div>
      <div class="col-md-12 text-center">
        <h1 class="bold300 text-uppercase" style=" font-weight:500;">Participaciones Federales a Municipios</h1>
      </div>
      <div
        v-if="dataParticipacionFedMpo && dataParticipacionFedMpo.length"
        class="col-md-12"
      >
        <div v-for="(item, index) in dataParticipacionFedMpo" :key="index">
          <table-section :section="item" :urlServe="urlServe" />
        </div>
        <!-- <table-section :sections="dataParticipacionFedMpo" :urlServe="urlServe"/> -->
      </div>
      <div class="col-md-12 text-center">
          <p class="mt-2 bold300 text-uppercase" style="font-size:2rem; font-weight:500;">Seleccione el año a consultar</p>
          <px-select idSelect="anio_pe" placeholder="Seleccione" :options="yearOptions" @KuramaSelect="anioSelected = $event"></px-select>
          <tabla :sections="dataParticipacionFedMpoDos" :urlServe="urlServe" />
          
      </div>
      <!-- <div  v-for="(objetos, anio) in mapeo" :key="anio" class="col-md-12 mt-2">
       <h3>Año: {{ anio.split(':')[1] }}</h3>
       <div v-for="(contenido, index) in objetos" :key="index">
        <p>Conteido (Titulo sección):</p>{{contenido}}
        <p>........</p>

       </div>
      </div> -->
    </div>
    <span v-html="fecha_actualizacion"></span>
  </div>
  
</template>
<script>
import mapFun from "@/common/map-fn-types.js";
import mixin from "@/mixins/mixin.js";
import RecursosMunicipios from "@/services/rendicionDeCuentas/recursosMunicipios/recursosMunicipios.js";
const recursosMunicipios_Service = new RecursosMunicipios();
import botonAtras from "../../button-atras";

import tableSection from "../../../components/simpleTableDos.vue";
import tabla from "../../../components/tableModelo5.vue";
import DateFormat from "@/mixins/dateFormatMixin.js";

export default {
  components: { botonAtras, tableSection, tabla },
  data() {
    return {
      dataParticipacionFedMpo: [],
      dataParticipacionFedMpoDos: [],
      dataAll:[],
      mapeo: [],
      yearOptions:[],
      anioSelected: null,
      fecha_actualizacion:''
    };
  },
  async created() {
    this.getParticipacionFedMpo();
    this.getParticipacionFedMpoDos();
    window.scrollTo(0, 0);
  },
  mixins: [mixin, DateFormat],
  methods: {
    async getParticipacionFedMpo() {
      try {
        const response =
          await recursosMunicipios_Service.getParticipacionesFederalesMunicipiosUno(
            mapFun.participacionesFederalesMunicipiosUno
          );
        this.dataParticipacionFedMpo = response;
        console.log("data ", this.dataParticipacionFedMpo);
      } catch (error) {
        console.log("error vista", error.message);
      }
    },
    async getParticipacionFedMpoDos() {
      try {
        const response =
          await recursosMunicipios_Service.getParticipacionesFederalesMunicipiosDos(
            mapFun.participacionesFederalesMunicipiosDos
          );
        this.dataAll = response;
        let fecha_texto = this.dataAll[0].fecha_actualizacion;
        this.fecha_actualizacion = this.DateFormatText(fecha_texto);
        // console.log("data dos ", this.dataParticipacionFedMpoDos);
      } catch (error) {
        console.log("error vista", error.message);
      }
    },
    async getAniosDocs() {
      try {
        this.yearOptions = this.dataAll.map(function (mapeoSelect) {
          return {
            id: mapeoSelect.id,
            value: mapeoSelect.titulo,
            text: mapeoSelect.titulo,
          };
        });
      } catch (error) {
        console.log("error", error.message);
      }
    },
    async getParticipacionFedMpoDosPorAnio(){
      try {
        this.dataParticipacionFedMpoDos = this.dataAll.filter(item => item.titulo === this.anioSelected.value);
      } catch (error) {
        console.log('error:', error.message);
      }
    }
  },
  watch:{
    dataAll(){
      if(this.dataAll){
        this.getAniosDocs();
      }
    },
    anioSelected(){
      this.getParticipacionFedMpoDosPorAnio();
    }
  }
};
</script>
